import type { MechanicStepDefaultValuesType } from 'entities/mechanic/model';
import { CalculationFunctionValuesEnum } from 'entities/mechanic/model';

export const useMechanicStepDefaultValues = (
  calculationFunction: CalculationFunctionValuesEnum,
  isIndividual: boolean,
): MechanicStepDefaultValuesType => {
  const getTargetValue = (
    calculationFunction: CalculationFunctionValuesEnum,
  ): MechanicStepDefaultValuesType['target'] => {
    switch (calculationFunction) {
      case CalculationFunctionValuesEnum.CF1:
        if (isIndividual) {
          return {
            visibleValue: 'Недоступно для заполнения',
            techValue: null,
            disabled: true,
            type: 'text',
          };
        }
        return null;

      case CalculationFunctionValuesEnum.CF2: {
        if (isIndividual) {
          return {
            visibleValue: 'Недоступно для заполнения',
            techValue: null,
            disabled: true,
            type: 'text',
          };
        }
        return null;
      }
      case CalculationFunctionValuesEnum.CF3:
        return {
          visibleValue: 'Регистрация',
          techValue: 1,
          disabled: true,
          type: 'text',
        };
      case CalculationFunctionValuesEnum.CF5:
        return {
          visibleValue: 'Аудит',
          techValue: 1,
          disabled: true,
          type: 'text',
        };
      case CalculationFunctionValuesEnum.CF6: {
        if (isIndividual) {
          return {
            visibleValue: 'Недоступно для заполнения',
            techValue: 1,
            disabled: true,
            type: 'text',
          };
        }
        return null;
      }
      default:
        return null;
    }
  };

  const getRewardValue = (): MechanicStepDefaultValuesType['reward'] => null;

  return {
    target: getTargetValue(calculationFunction),
    reward: getRewardValue(),
  };
};
